<template>
    <div>
        <treeselect
            @input="onChange"
            :multiple="multiple"
            :options="options"
            noChildrenText=""
            :disableBranchNodes="true"
            :normalizer="normalize"
            v-model="selected"
        />
    </div>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue'
import Treeselect from '@riophae/vue-treeselect'
import {SupplyChain} from "@core/api";
export default {
    components: {
        Treeselect,
        BFormGroup
    },
    props: {
        multiple: {
            default: true
        }
    },
    data() {
        return {
            options: [],
            selected: null,
            timer: null,
        };
    },
    methods: {
        onChange() {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.$emit('search', this.selected);
            }, 400);
        },
        normalize(node) {
            return {id: node.id, label: node.title};
        },
    },
    mounted() {
        SupplyChain.getBusinessRoles().then(r => this.options = r.data);
    }
}
</script>

<style lang="css">
@import '../../../../../node_modules/@riophae/vue-treeselect/dist/vue-treeselect.css';
</style>
